import * as Tone from 'tone';

// Polyphonic synth with selectable oscillator type. Becomes one mixer channel
// + one pitched lane in the channel rack.

export default {
    id: 'synth',
    name: 'Synth',
    register(ctx) {
        const channel = ctx.mixer.addChannel({ id: 'synth', name: 'Synth', color: '#c586c0' });
        channel.setVolume(-6);

        const synth = new Tone.PolySynth(Tone.Synth, {
            oscillator: { type: 'sawtooth' },
            envelope: { attack: 0.01, decay: 0.15, sustain: 0.3, release: 0.4 },
        });
        synth.connect(channel.input);

        ctx.instruments.register({
            id: 'synth',
            name: 'Synth',
            kind: 'pitched',
            channelId: 'synth',
            play(note, time, duration = '8n', velocity = 0.85) {
                try { synth.triggerAttackRelease(note, duration, time, velocity); } catch (_) {}
            },
            setOscillator(type) { synth.set({ oscillator: { type } }); },
        });

        ctx.lanes.add({
            id: 'synth',
            name: 'Synth',
            instrumentId: 'synth',
            kind: 'pitched',
            color: '#c586c0',
            defaultOctave: 4,
            // Channel-rack UI exposes these on the lane header.
            params: [
                {
                    type: 'select', label: 'Wave', key: 'oscillator',
                    options: [
                        { value: 'sawtooth', label: 'Saw' },
                        { value: 'square', label: 'Square' },
                        { value: 'triangle', label: 'Triangle' },
                        { value: 'sine', label: 'Sine' },
                    ],
                    default: 'sawtooth',
                    onChange: (v) => ctx.instruments.get('synth').setOscillator(v),
                },
            ],
        });
    },
};
